import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedUserSource: cacheLs.get_user_source()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
